import {instance} from '../index';

export const availabilitiesAPI = {
    getCharterAvailabilities () {
        return instance.get('aircrafts/availability/list')
    },
    getFlightAvailabilities () {
        return instance.get('emptylegs/list')
    },
}